export default __webpack_public_path__ + "static/media/Hour Track.1be7a8f9.PNG";